export default __webpack_public_path__ + "98b04012e41460ad72796d7db3582197.png";